import * as React from 'react';
import { observer } from 'mobx-react';
import StatusSummaryButton from 'nomst/Components/SummaryDashboard/statusSummaryButton';
import { PromotionSummaryId, PromotionSummaryIdNumber } from 'typings/promotionEnum';
import { navigateToNoMst } from 'utils/MobxDataManager/singletons';

export interface IPromotionRequestSummaryViewProps {
    promotionRequestSummaries: IStatusSummary[];
}

export class PromotionRequestSummaryView extends React.Component<IPromotionRequestSummaryViewProps> {
    constructor(props: IPromotionRequestSummaryViewProps) {
        super(props);
        this.navigateToPromotions = this.navigateToPromotions.bind(this);
    }

    render(): React.ReactNode {
        const { promotionRequestSummaries } = this.props;

        const statusCount = promotionRequestSummaries?.reduce((total, promotionRequestSummary) =>
            total + promotionRequestSummary.statusCount, 0) ?? 0;
        const promotionClass = statusCount > 0 ? '' : 'promotion-requests__content--unclickable';
        return (
            <div className="promotion-requests">
                <h2 className="promotion-requests__heading">Promotion Requests</h2>
                <button
                    className={`promotion-requests__content-button ${promotionClass}`}
                    onClick={this.navigateToPromotions} type="button"
                >
                    <div className="promotion-requests__content" >
                        <i className="icon-star"/>
                        {this.renderPromotionRequestSummary(statusCount)}
                    </div>
                </button>
            </div>
        );
    }

    renderPromotionRequestSummary(statusCount: number): React.ReactNode {
        const statusSummary: IStatusSummary = {
            statusCount,
            status: ''
        };
        return (
            <div
                key={status}
                className="promotion-requests__category promotion-requests__category--all-jobs"
            >
                <p className="promotion-requests__count">
                    <StatusSummaryButton
                        statusSummary={statusSummary}
                    />
                </p>
                <p className="promotion-requests__status">All Jobs</p>
            </div>
        );
    }

    async navigateToPromotions(): Promise<void> {
        await navigateToNoMst.navigateToPromotionsView();
    }

    convertSummaryStatusToNumber(status: string): number {
        switch (status) {
            case PromotionSummaryId.ExistingJobs:
                return PromotionSummaryIdNumber.ExistingJobs;
            case PromotionSummaryId.NewJobs:
                return PromotionSummaryIdNumber.NewJobs;
            default:
                return PromotionSummaryIdNumber.ExistingJobs;
        }
    }
}

export default observer(PromotionRequestSummaryView);